import { render, staticRenderFns } from "./HomePanelVertical2.vue?vue&type=template&id=7c530317&"
import script from "./HomePanelVertical2.vue?vue&type=script&lang=js&"
export * from "./HomePanelVertical2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports